import { Directive, effect, ElementRef, input } from '@angular/core';
import { MobileStatusBarMode } from '../../hybrid/models/status-bar-text-color';
import { StatusBarService } from '@core-services/status-bar.service';

@Directive({
    selector: '[statusBarMode]',
})
export class StatusBarModeDirective {

    public whenVisible = input<keyof typeof MobileStatusBarMode>();
    public whenNotVisible = input<keyof typeof MobileStatusBarMode>();

    private isActive = false;

    constructor(
        private readonly container: ElementRef<HTMLElement>,
        private readonly statusBarService: StatusBarService,
    ) {
        effect((onCleanup) => {

            const observer = new IntersectionObserver(([entry]) => {

                if (entry.isIntersecting) {
                    const currentMode = MobileStatusBarMode[this.whenVisible()];

                    this.statusBarService.set(this, currentMode);
                    this.isActive = true;
                } else {
                    if (this.isActive) {
                        const currentMode = MobileStatusBarMode[this.whenNotVisible()];

                        this.statusBarService.set(this, currentMode);

                        this.isActive = false;
                    }
                }
            });

            observer.observe(container.nativeElement);

            onCleanup(() => {
                observer.disconnect();

                if (this.isActive) {
                    this.statusBarService.pop(this);
                    this.isActive = false;
                }
            });
        });
    }

}